"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
export default function OurHistory() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const timeline = [{
    year: "1997",
    title: "The Beginning",
    description: "In 1997, Luis Antonio Scheker embarked on his culinary journey by opening his first restaurant, El Rancho, in the heart of Indianapolis. This marked the beginning of his passion for bringing authentic Mexican flavors to the community. From day one, his commitment to quality ingredients and warm hospitality set the foundation for future success."
  }, {
    year: "2016",
    title: "Community Favorite",
    description: "After receiving success from his prior Mexican restaurants, Luis established a new location named Caliente in Carmel in 2016. This strategic expansion gave him a strong foothold in the Carmel area, where the restaurant quickly became a beloved local favorite. The community embraced the authentic flavors and welcoming atmosphere that Luis had perfected over the years."
  }, {
    year: "2019",
    title: "Texas Twist",
    description: "Mr. Scheker didn't stop there—he expanded into Whitestown and established Texas Margaritas in 2019, right in the midst of the pandemic. Despite facing unprecedented challenges, he beat all odds and turned the restaurant into a thriving community favorite. Today, the brand continues to grow into Carmel and Westfield, securing dominance in the area with its unique Texas-Mexican fusion."
  }, {
    year: "2025",
    title: "Today",
    description: "Continuing to serve Carmel and surrounding communities with the same authentic recipes and family-friendly atmosphere that started it all. Luis and his two sons are now working together to continue that legacy, expanding the Texas Margaritas brand and putting it firmly on the map. Their dedication to quality, service, and community remains unwavering as they build on decades of culinary excellence."
  }];
  return <section className="relative w-full min-h-[600px] overflow-hidden bg-cover bg-center !bg-[url(https://texasmargaritasmexicanrestaurant.com/wp-content/uploads/2026/01/TXM-whitestown.webp)]">
      {}
      <div className="absolute inset-0 bg-primary/30"></div>

      <div ref={ref} className={`relative z-10 container mx-auto px-6 py-20 transition-all duration-[250ms] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        <div className="max-w-4xl mx-auto">
          <Card className="relative overflow-hidden group hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] shadow-medium hover:shadow-strong">
            <CardHeader className="text-center pb-4">
              <CardTitle className="text-4xl font-display text-black">
                Our History
              </CardTitle>
            </CardHeader>

            <CardContent className="relative">
              {}
              <div className="space-y-8">
                {timeline.map((item, i) => <div key={item.year} data-index={i} className="flex gap-6 items-start">
                    <div className="flex-shrink-0 w-20 text-right">
                      <span className="text-2xl font-display font-bold text-black">
                        {item.year}
                      </span>
                    </div>
                    <div className="flex-1 border-l-2 border-primary/40 pl-6 pb-2">
                      <h3 className="text-xl font-display font-semibold text-black mb-2">
                        {item.title}
                      </h3>
                      <p className="text-white leading-relaxed">
                        {item.description}
                      </p>
                    </div>
                  </div>)}
              </div>

              {}
              
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}